import store from '@/store/index'
import router from '@/router'

import { createLogger } from './log'

export const EventTypes = Object.freeze({
  STORE: Symbol('STORE'),
  ROUTE: Symbol('ROUTE'),
  MANUAL: Symbol('MANUAL'),
})

export const StoreEvents = Object.freeze({
  DEACTIVATE_ANALYTICS: Symbol('DEACTIVATE_ANALYTICS'),
  ACTIVATE_ANALYTICS: Symbol('ACTIVATE_ANALYTICS'),
  PRODUCT_ADDED: Symbol('PRODUCT_ADDED'),
  PRODUCT_REMOVED: Symbol('PRODUCT_REMOVED'),
  PRODUCT_UPDATED: Symbol('PRODUCT_UPDATED'),
  REDUCTION_INFO_UPDATED: Symbol('REDUCTION_INFO_UPDATED'),
  SEARCH_PRODUCTS_UPDATED: Symbol('$_search/PRODUCTS_UPDATED'),
  HOTEL_OFFER_LOADED: Symbol('$_hotel/OFFER_LOADED'),
  CHECKOUT_PAYMENT_STARTED: Symbol('$_checkout/PAYMENT_CHECKOUT_STARTED'),
  CHECKOUT_USER_DATA_UPDATED: Symbol('$_checkout/USER_DATA_UPDATED'),
  CHECKOUT_ORDER_CLOSED: Symbol('$_checkout/ORDER_CLOSED'),
  CHECKOUT_PAYMENT_SESSION_UPDATED: Symbol(
    '$_checkout/PAYMENT_SESSION_UPDATED',
  ),
})

export const ManualEvents = Object.freeze({
  CLICKED: Symbol('CLICKED'),
})

export const dispatcher = {
  log: undefined,
  subscribers: [],
  storeUnsubscriber: null,
  routeUnsubscriber: null,
  dispatch(event, payload) {
    this.log.print('called dispatch()', {
      event: event,
      payload: payload,
    })
    if (
      this.subscribers[EventTypes.MANUAL][event] &&
      this.subscribers[EventTypes.MANUAL][event].length > 0
    ) {
      for (const sub of this.subscribers[EventTypes.MANUAL][event]) {
        sub.action(payload)
      }
    }
  },
  setup() {
    this.log = createLogger("DISPATCHER", "📌", false)
    this.log.print('called setup()')
    this.subscribers[EventTypes.STORE] = []
    for (const st in StoreEvents) {
      this.subscribers[EventTypes.STORE][StoreEvents[st].description] = []
    }
    this.subscribers[EventTypes.ROUTE] = []
    this.subscribers[EventTypes.MANUAL] = []
    this.subscribers[EventTypes.MANUAL][ManualEvents.CLICKED.toString()] = []

    this.storeUnsubscriber = store.subscribe((mutation) => {
      if (
        this.subscribers[EventTypes.STORE][mutation.type] &&
        this.subscribers[EventTypes.STORE][mutation.type].length > 0
      ) {
        for (const sub of this.subscribers[EventTypes.STORE][mutation.type]) {
          sub.action(mutation)
        }
      }
    })
    this.routeUnsubscriber = router.afterEach((to, from) => {
      if (
        this.subscribers[EventTypes.ROUTE][to.name] &&
        this.subscribers[EventTypes.ROUTE][to.name].length > 0
      ) {
        for (const sub of this.subscribers[EventTypes.ROUTE][to.name]) {
          sub.action(to, from)
        }
      }
    })
  },
  destroy() {
    this.log.print('called destroy()')
    try {
      if (this.storeUnsubscriber) {
        this.storeUnsubscriber()
      }
      if (this.routeUnsubscriber) {
        this.routeUnsubscriber()
      }
    } catch (err) {
      this.log.print('err destroy()', err)
    }
  },
  _register(subscriber) {
    this.log.print('called _register()', subscriber)
    switch (subscriber.$type) {
      case EventTypes.STORE:
        if (
          typeof subscriber.handle === 'string' ||
          subscriber.handle instanceof String
        ) {
          this.subscribers[subscriber.$type][subscriber.handle].push(subscriber)
        } else {
          this.subscribers[subscriber.$type][
            subscriber.handle.description
          ].push(subscriber)
        }

        return true
      case EventTypes.ROUTE:
      case EventTypes.MANUAL:
        if (!this.subscribers[subscriber.$type][subscriber.handle]) {
          this.subscribers[subscriber.$type][subscriber.handle] = []
        }
        this.subscribers[subscriber.$type][subscriber.handle].push(subscriber)
        return true
    }
    return false
  },
  register(subscriber) {
    if (Array.isArray(subscriber)) {
      for (const s of subscriber) {
        this._register(s)
      }
    } else {
      this._register(subscriber)
    }
  },
}

export const storeEventLister = (ev, action) => {
  return {
    $type: EventTypes.STORE,
    handle: ev,
    action: action,
  }
}

export const routeEventListener = (ev, action) => {
  return {
    $type: EventTypes.ROUTE,
    handle: ev,
    action: action,
  }
}

export const manualEventListener = (ev, action) => {
  return {
    $type: EventTypes.MANUAL,
    handle: ev,
    action: action,
  }
}
